import { SvgIcon, SvgIconProps } from '@mui/material';

const PeopleFilled = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="PeopleFilledIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path d="M16.5 12.5C17.5802 12.5 19.1368 12.6259 20.458 13.2627C21.1319 13.5876 21.7773 14.0611 22.2529 14.748C22.7343 15.4433 23 16.2977 23 17.3076V18.333C23 19.2535 22.2535 20 21.333 20L15.0264 20.0088C15.0264 20.0088 15.348 19.8228 15.5312 19.2305C15.75 18.5234 15.75 17.9961 15.75 17.9961C15.7762 17.236 15.7095 16.4846 15.5566 15.8193C15.4038 15.1541 15.3405 14.9069 15.0137 14.2383C14.6866 13.5693 14.0156 12.7266 14.0156 12.7266C14.8179 12.5317 15.8613 12.5 16.5 12.5Z" />
      <path d="M7.49805 12.5C8.57816 12.5 10.1349 12.626 11.4561 13.2627C12.1299 13.5876 12.7754 14.0612 13.251 14.748C13.7323 15.4433 13.998 16.2977 13.998 17.3076V18C13.998 19.1046 13.1026 20 11.998 20H2.99805C1.89359 19.9999 0.998047 19.1045 0.998047 18V17.3076C0.99806 16.2977 1.26385 15.4432 1.74512 14.748C2.22067 14.0612 2.86618 13.5876 3.54004 13.2627C4.86117 12.6259 6.41789 12.5 7.49805 12.5Z" />
      <path d="M7.33398 4C9.35877 4.00031 11 5.64214 11 7.66699C10.9998 9.6917 9.35866 11.3327 7.33398 11.333C5.30905 11.333 3.66717 9.69189 3.66699 7.66699C3.66699 5.64195 5.30894 4 7.33398 4Z" />
      <path d="M16.6641 4C18.6888 4.00031 20.3301 5.64214 20.3301 7.66699C20.3299 9.6917 18.6887 11.3327 16.6641 11.333C14.6391 11.333 12.9972 9.69189 12.9971 7.66699C12.9971 5.64195 14.639 4 16.6641 4Z" />
    </SvgIcon>
  );
};

export default PeopleFilled;
